<div class="dashboard-wrapper" style="overflow-x:auto">
  <div class="v-card">
    @if (showWorkflow) {
      <div class="workflow-background"></div>
    }

    @if (showWorkflow) {
      <div class="user-workflow-component" [ngClass]="{'user-workflow-on-mobile' : isMobile}" >
        <div class="workflow-box" cdkDrag  handleResize  [(height)]="boxHeight" [(width)]="boxWidth"
          [style.width.px]="boxWidth" [style.height.px]="boxHeight" [maxWidth]="700" [maxHeight]="700" [minWidth]="400" [minHeight]="300">
                <div cdkDragHandle style="cursor: move;border-bottom: solid 1px #eeeeee;
                padding-bottom: 5px;">
            <div class="d-flex align-items-center">
              <div class="col-2 h-100 text-start ps-3">
                <img src="assets/img/amblem.svg" alt="" style="height: 26px;">
              </div>
              <div class="col-8 text-center">
                @if (wfName) {
                  <label class="cursor-move text-grey">{{wfName}}</label>
                }
              </div>
              <div class="col-2 d-flex align-items-center justify-content-end">
                @if (isStepFileAvailable && isStart) {
                  <div class="me-2">
                    <img src="assets/img/step-files-icon.svg" alt="" class="cursor-pointer" (click)="showStepFiles()">
                  </div>
                }
                @if (workflow.showContentPage || isEwers || (workflow.expertsToCall?.length > 0)) {
                  <div class="me-2" [ngStyle]="{'pointer-events': isStart ? '' : 'none'}">
                    <img src="assets/img/list-content.svg" class="cursor-pointer" alt="" height="13px" (click)="switchWorkflowMenu()">
                  </div>
                }
                <div class="close text-grey" (click)="close()">
                  <img src="assets/img/close-workflow.svg" height="14px">
                </div>
              </div>
            </div>
          </div>
          <app-user-workflow style="display:block; height:100%; width: 100%;margin-top: 20px;min-width: 200px;min-height:200px;"
            [workflow]="workflow"
            (workflowSubmitted)= "workflowSubmitted($event)"
            [(savedDraft)]= "savedDraft"
            (savedDraftChage)= "savedDraftChage($event)"
            [results]= "results"
            [report]= "report"
            [reportId]= "reportId"
            (isWorkflowStart)="isWorkflowStart($event)"
            (langChanged)="langChanged($event)"
            [(workflowMenuClicked)]="workflowMenuClicked"
            (workflowMenuClickedChange)= "workflowMenuClickedChange($event)"
            [(stepFilesClicked)]="stepFilesClicked"
            (isStepFileAvailable)="stepFileAvailability($event)"
          ></app-user-workflow>
          <div class="handler"></div>
        </div>
      </div>
    }

    <div class="card list-header list-header-fixed flex-row justify-content-between align-items-center pe-4 ps-4">
      <div class="d-flex">
        <div class="header fs-20 font-weight-700  pt-1 me-2">{{ 'MAIN.CONTENT.DASHBOARD.TITLE' | translate }}</div>
        @if (('electron' | env)) {
          <div>
            <button (click)="exportPublishedWorkflows()" class="v-btn btn btn-primary fs-12 font-weight-600 text-white" style="border-radius:7px; height: 30px;padding-top:5px">{{ 'MAIN.CONTENT.DASHBOARD.EXPORT-WORKFLOWS' | translate }}</button>
          </div>
        }
      </div>
      <div><button class="v-btn btn btn-primary fs-15 font-weight-600 text-white create-button" (click)="selectContentLanguage()">{{ 'MAIN.CONTENT.DASHBOARD.WORKFLOW-TABLE.CONTENT-LANGUAGE' | translate | titlecase }}</button></div>
    </div>

    <div class="card tab-area d-flex flex-row first-area">
      <div class="tab-item right fs-16 font-weight-600 ms-4 selected-tab">
        <span class="tab-title">{{ 'MAIN.CONTENT.DASHBOARD.TABS.MY-WORKFLOWS' | translate }}</span>
      </div>
      @if (isAdmin || hasEditorAccess) {
        <div class="tab-item right fs-16 font-weight-600 ms-4" (click)="onAllWorkflows()">
          <span class="tab-title">{{ 'MAIN.CONTENT.DASHBOARD.WORKFLOW-TABLE.MANAGE-WORKFLOWS' | translate }}</span>
        </div>
      }
      <div class="tab-item right fs-16 font-weight-600 ms-4" (click)="onSubmittedWorkflows()">
        <span class="tab-title">{{ 'MAIN.CONTENT.DASHBOARD.TABS.SUBMITTED-WORKFLOWS' | translate }}</span>
      </div>
    </div>

    <div class="card list-area">
      <app-dashboard-filter [allLabels]="allLabels"
        [showAdvancedSearch]="true"
        (onFilter)="onFilterChange($event)"
      (onAdvancedSearch)="openSearchDialog()"></app-dashboard-filter>

      @if (workflowList && workflowList.workflowList && workflowList.workflowList.length > 0) {
        <div class="pe-4 ps-3 filter-area">
          @if (isSearchApplied) {
            <div class="mt-3 d-flex flex-wrap">
              <span class="fs-14 me-2 font-weight-600 ms-1">{{ 'MAIN.CONTENT.DASHBOARD.SEARCH.APPLIED' | translate }} : </span>
              <span class="fs-12 font-weight-500 label-span me-2 mb-2">"{{ searchQuery }}" <img (click)="clearSearchFilter()" class="label-close cursor-pointer" src="assets/img/close.svg" alt=""></span>
              <span class="fs-14 font-weight-600 cursor-pointer text-blue" (click)="clearSearchFilter()">{{ 'MAIN.CONTENT.DASHBOARD.SEARCH.CLEAR' | translate }}</span>
            </div>
          }
        </div>
      }

      <div class="user-table-header d-flex align-items-center">
        <div class="col-4 fs-14 d-flex align-items-center cursor-pointer fs-14 text-dark-grey" style="padding-left: 20px;" (click)="sortByName()">
          {{ 'MAIN.CONTENT.DASHBOARD.WORKFLOW-TABLE.NAME' | translate }}

          @if (order == 'asc') {
            <img src="assets/img/down-icon-grey.svg" alt="" class="folder-icon">
          }
          @if (order == 'desc') {
            <img src="assets/img/down-icon-grey.svg" style="transform:rotate(180deg)" alt="" class="folder-icon">
          }
          @if (!order) {
            <div class="p-relative ms-1 cursor-pointer" style="height:24px;" (click)="sortByName()">
              <img src="assets/img/down-icon-grey.svg" style="transform:rotate(180deg)" alt="" class="sort-icon up">
              <img src="assets/img/down-icon-grey.svg" alt="" class="sort-icon down">
            </div>
          }
        </div>
        <div class="col-2 fs-14 text-dark-grey">{{ 'MAIN.CONTENT.DASHBOARD.WORKFLOW-TABLE.VERSION' | translate }}</div>
        <div class="col-3 fs-14 text-dark-grey d-flex align-items-center cursor-pointer" (click)="sortByPublishDate()">
          {{ 'MAIN.CONTENT.DASHBOARD.WORKFLOW-TABLE.PUBLISHED-AT' | translate }}
          @if (publishDateOrder == 'asc') {
            <img src="assets/img/down-icon-grey.svg"  alt="" class="folder-icon">
          }
          @if (publishDateOrder == 'desc') {
            <img src="assets/img/down-icon-grey.svg" style="transform:rotate(180deg)" alt="" class="folder-icon">
          }
          @if (!publishDateOrder) {
            <div class="p-relative ms-1 cursor-pointer" style="height:24px;" (click)="sortByName()">
              <img src="assets/img/down-icon-grey.svg" style="transform:rotate(180deg)" alt="" class="sort-icon up">
              <img src="assets/img/down-icon-grey.svg" alt="" class="sort-icon down">
            </div>
          }
        </div>
        <div class="col-3 fs-14 text-dark-grey">{{ 'MAIN.CONTENT.DASHBOARD.WORKFLOW-TABLE.LANGUAGES' | translate }}</div>
      </div>
      <div class="user-table-body">
        <!-- My Workflows and Shared Workflows -->
        @if (!folders || !folders.length || (!workflowList || !workflowList?.workflowList?.length)) {
          <div class="empty-list fs-14 text-grey">{{ 'MAIN.CONTENT.DASHBOARD.FOLDER.NO-WORKFLOW-FOUND' | translate }}</div>
        }

        @for (folder of filteredWorkflowList['folders']; track folder) {
          <div>
            @if (folders?.length && folders?.length > 1) {
              <div  class="folder-card fs-15 font-weight-700 ps-3 d-flex align-items-center cursor-pointer" (click)="changeFolderStatus(folder)">
                @if (folder && folder['openStatus']) {
                  <img src="assets/img/down-icon-black.svg" style="transform:rotate(360deg)" alt="" class="folder-icon">
                }
                @if (folder && !folder['openStatus']) {
                  <img src="assets/img/down-icon-black.svg"  style="transform: rotate(270deg)" alt="" class="folder-icon">
                }
              {{folder.name}}</div>
            }
            @if (folder.workflowList && (folder['openStatus'] ||  folders?.length == 1)) {
              <div class="workflow-table-body">
                @for (workflow of folder.workflowList; track workflow) {
                  <div class="workflow-card d-flex align-items-center">
                    <div class="col-4 fs-15 font-weight-700" [ngStyle]="{'padding-left': folders?.length == 1 ? '20px' : '40px'}">
                      {{workflow.listName}}
                      @if (workflow.isShared && (isAdmin || hasEditorAccess)) {
                        <span class="badge bg-info fs-10 font-weight-400 ms-1" style="vertical-align: middle;">S</span>
                      }
                    </div>
                    <div class="col-2 fs-14">v{{workflow.version}}</div>
                    <div class="col-3 fs-14 font-weight-400" title="{{workflow.publishedAt | localizedDate | async}}">{{ workflow.publishedAt | localizedDateShort | async}}</div>
                    <div class="col-1 fs-14 font-weight-400">
                      @if (workflow.translations) {
                        @for (code of workflow.translations | keyvalue; track code; let index = $index) {
                          <span>
                            @if (code?.key && index<4) {
                              <span>{{$any(code.key) | uppercase}}@if (index !== (workflow.translations | keyvalue).length-1 && index<3) {
                                <span>,</span>
                              }
                            </span>
                          }
                        </span>
                      }
                      @if ((workflow.translations | keyvalue).length>=4) {
                        <span>...</span>
                      }
                    }
                  </div>
                  <div class="col-2 d-flex justify-content-end align-items-center" style="padding-right: 30px;">
                    <button class="v-btn btn btn-secondary-outline fs-16 font-weight-600" (click)="selectSingleWorkflow(workflow)">{{ 'MAIN.CONTENT.DASHBOARD.WORKFLOW-TABLE.START' | translate }}</button>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

</div>
